import * as React from 'react';
import { useMemo } from 'react';
import { useMediaQuery } from 'react-responsive';

import { Breakpoint } from '../../enums';

import {
  BiggerImage,
  Column,
  Container,
  ImageButton,
  ImageLabel,
  LeftColumn,
  RightColumn,
  Row,
  SmallerImage
} from './collectionSection.styled';
import { CollectionSectionProps } from './collectionSection.types';

export const CollectionSection: React.FC<CollectionSectionProps> = (props: CollectionSectionProps) => {
  const { items, className }: CollectionSectionProps = props;
  const isSmallMobile: boolean = useMediaQuery({ query: Breakpoint.SmallMobile });
  const indexShift: number = useMemo((): number => items.length >= 5 ? 1 : 0, [items.length]);

  if (items.length >= 4) {
    return (
      <Container className={className}>
        {(items.length >= 5) && (
          <LeftColumn onClick={items[0].onClick}>
            <ImageButton $backgroundImage={items[0].backgroundImage} />
            <ImageLabel>{items[0].label}</ImageLabel>
          </LeftColumn>
        )}
        <RightColumn $fullWidth={items.length < 5}>
          {!isSmallMobile ? (
            <>
              <Row>
                <BiggerImage onClick={items[0 + indexShift].onClick}>
                  <ImageButton $backgroundImage={items[0 + indexShift].backgroundImage} />
                  <ImageLabel>{items[0 + indexShift].label}</ImageLabel>
                </BiggerImage>
                <SmallerImage onClick={items[1 + indexShift].onClick}>
                  <ImageButton $backgroundImage={items[1 + indexShift].backgroundImage} />
                  <ImageLabel>{items[1 + indexShift].label}</ImageLabel>
                </SmallerImage>
              </Row>
              <Row>
                <SmallerImage onClick={items[2 + indexShift].onClick}>
                  <ImageButton $backgroundImage={items[2 + indexShift].backgroundImage} />
                  <ImageLabel>{items[2 + indexShift].label}</ImageLabel>
                </SmallerImage>
                <BiggerImage onClick={items[3 + indexShift].onClick}>
                  <ImageButton $backgroundImage={items[3 + indexShift].backgroundImage} />
                  <ImageLabel>{items[3 + indexShift].label}</ImageLabel>
                </BiggerImage>
              </Row>
            </>
          ) : (
            <>
              <Column>
                <BiggerImage onClick={items[0 + indexShift].onClick}>
                  <ImageButton $backgroundImage={items[0 + indexShift].backgroundImage} />
                  <ImageLabel>{items[0 + indexShift].label}</ImageLabel>
                </BiggerImage>
                <SmallerImage onClick={items[2 + indexShift].onClick}>
                  <ImageButton $backgroundImage={items[2 + indexShift].backgroundImage} />
                  <ImageLabel>{items[2 + indexShift].label}</ImageLabel>
                </SmallerImage>
              </Column>
              <Column>
                <SmallerImage onClick={items[1 + indexShift].onClick}>
                  <ImageButton $backgroundImage={items[1 + indexShift].backgroundImage} />
                  <ImageLabel>{items[1 + indexShift].label}</ImageLabel>
                </SmallerImage>
                <BiggerImage onClick={items[3 + indexShift].onClick}>
                  <ImageButton $backgroundImage={items[3 + indexShift].backgroundImage} />
                  <ImageLabel>{items[3 + indexShift].label}</ImageLabel>
                </BiggerImage>
              </Column>
            </>
          )}
        </RightColumn>
      </Container>
    );
  }

  return <></>;
};
